export { default } from './svg/spacing-tight.svg';
